import React, { FC } from "react";
import { Button, TButtonProps } from "kanopi-components/Button";
import { SIZE as BUTTON_SIZE } from "baseui/button";
import { useNavigate } from "@reach/router";

type TAdminHijackUserButton = {
  userId: string;
  userIsActive: boolean;
};
export const AdminHijackUserButton: FC<TAdminHijackUserButton & TButtonProps> = ({
  userId,
  userIsActive,
  ...buttonProps
}) => {
  const navigate = useNavigate();

  const hijackUser = () => {
    navigate(`/user-hijacking/hijack/${userId}`);
  };

  return (
    userIsActive && (
      <Button
        size={BUTTON_SIZE.compact}
        outlined={true}
        onClick={hijackUser}
        data-testid="hijackUserButton"
        {...buttonProps}
      >
        Access Customer Account
      </Button>
    )
  );
};
